import { configEnv } from '@libraries/config';

export const loginSliderData: ILoginSlider[] = [
  {
    id: 1,
    bg: `${configEnv.assetUrl}/img/login/slide-1.webp`,
    title: 'Selamat Datang di WMS PLN',
    description:
      'Sistem manajemen gudang terintegrasi untuk mengelola inventaris dan operasional gudang PLN',
    footer: 'Copyright © 2026  PLN & Carte. All rights reserved.',
  },
  {
    id: 2,
    bg: `${configEnv.assetUrl}/img/login/slide-2.webp`,
    title: 'Pantau stok dan operasional gudang Anda melalui WMS PLN',
    description:
      'Dapatkan pembaruan dan laporan waktu nyata mengenai inventaris dan pengelolaan gudang.',
    footer: 'Copyright © 2026  PLN & Carte. All rights reserved.',
  },
];

export interface ILoginSlider {
  id: number;
  bg: string;
  title: string;
  description: string;
  footer: string;
}
